<template >
  <Content @back="$router.go(-1)" class="infoViewExpert">
    <template v-slot:nav_left>{{centerInfo.youth.youthShortName || '--'}}</template>
    <template v-slot:nav_right>
      <!--<router-link class="bg_btn" target="_blank" :to="{path: '/school/list', query: {organUuid:centerInfo.youth.organUuid,youthUuid:centerInfo.youth.uuid}}" >-->
        <!--体教融合-->
      <!--</router-link>-->
      <!--<router-link class="bg_btn" target="_blank" :to="{path: '/siteFacilities/list', query: {organUuid:centerInfo.youth.organUuid,youthUuid:centerInfo.youth.uuid}}"  style="margin-left:10px">-->
        <!--场地设施-->
      <!--</router-link>-->
      <!--<router-link class="bg_btn" target="_blank" :to="{path: '/record/list', query: {}}" style="margin-left:10px">-->
        <!--培养成效-->
      <!--</router-link>-->
      <router-link class="bg_btn" target="_blank" :to="{path: '/statisticsYouth', query: {uuid:centerInfo.youth.uuid}}" style="margin-left:10px">
        大数据
      </router-link>
      <template v-if="userRole === 'system' || userRole === 'admin'">
        <div  @click="handleUploadScore(true)" style="margin-left:10px;color:#f88594" v-if=" centerInfo.stageUuid">
          专家打分
        </div>
      </template>
      <template v-else>
        <div class="bg_btn" @click="handleUploadScore()" style="margin-left:10px;color:#f88594" v-if=" centerInfo.stageUuid">
          专家打分
        </div>
      </template>
    </template>
    <template v-slot:content_right>
      <div class="mainHead" style="min-height:158px">
        <div class="headInfo">
          <div class="logo">
            <img :src="centerInfo.youth.banner || centerImg" alt="" @error="centerInfo.youth.banner = centerImg">
          </div>
          <div class="info">
            <p>精英机构全称：{{centerInfo.youth.youthName}}</p>
            <div class="row">
              <p >管理单位：
                <span v-if="['市直属'].includes(centerInfo.youth.organShortName)">{{centerInfo.youth.organShortName}}</span>
                <span v-else-if="['浦东新区'].includes(centerInfo.youth.organShortName)">上海市浦东新区体育管理指导中心</span>
                <span v-else>{{centerInfo.youth.organShortName}}体育局</span>
              </p>
              <p class="item">精英机构地址：
                <span v-if="centerInfo.youth.uuid ==='b04aa53a719343ddb8880e2e56da676d'">绿舟基地（上海市青浦区）</span>
                <span v-else-if="centerInfo.youth.uuid ==='671c6ca6df5d41f1af79bdde91aefb03'">康桥基地（上海市浦东新区）</span>
                <span v-else> {{centerInfo.youth.cityName}}{{centerInfo.youth.countyName}}</span>
              </p>
            </div>
            <!--<div class="row">-->
              <!--<p >精英机构状态：{{centerInfo.youth.status | statusFilter }}</p>-->
              <!--<p class="item">管理员姓名：{{centerInfo.user.idName}}</p>-->
              <!--<p class="item">管理员手机号：{{centerInfo.user.phone}}</p>-->
            <!--</div>-->

            <div class="row" v-if="centerInfo.youthHeader">
              <p>法人：{{centerInfo.youthHeader.juridicalPerson}}</p>
              <p class="item">机构负责人姓名：{{centerInfo.youthHeader.youthHeader}}</p>
              <p class="item">青训总监姓名：{{centerInfo.youthHeader.youthDirectorName}}</p>
              <p class="item">青训总监教练证书：{{centerInfo.youthHeader.youthDirectorLevel}}</p>
            </div>
            <div class="row" v-if="centerInfo.youthHeader">
              <p>联络人姓名：{{centerInfo.youthHeader.linkman}}</p>
              <p class="item">联络人电话：<yioks-privacy-text type="phone" :value="centerInfo.youthHeader.linkmanPhone" /></p>
            </div>
            <div class="row">
              <p>球队数量：{{centerInfo.youth.squadNum}}</p>
              <p class="item">系统球员数量：{{centerInfo.youth.playerTeamNum}}</p>
              <p class="item">2026年注册球员数量：{{centerInfo.playerCareerNum}}</p>
              <p class="item">教练数量：{{centerInfo.youth.coachTeamNum}}</p>
            </div>
          </div>
        </div>
      </div>
      <div class="mainInfo">
        <div class="mokuai" v-if="centerInfo.types.includes('football') || centerInfo.types.includes('site') || centerInfo.types.includes('facilities')|| centerInfo.types.includes('school')|| centerInfo.types.includes('echelon')|| centerInfo.types.includes('footballproperty')|| centerInfo.types.includes('schooltrain')|| centerInfo.types.includes('team')|| centerInfo.types.includes('player')">
          <router-link target="_blank" :to="{path: '/siteFacilities/list', query: {organUuid:centerInfo.youth.organUuid,youthUuid:centerInfo.youth.uuid}}"  class="link" v-if="centerInfo.types.includes('football') || centerInfo.types.includes('site') || centerInfo.types.includes('facilities') || centerInfo.types.includes('footballproperty')">
            <!-- to="/performance/phaselist" -->
            <div class="box">
              <img src="@/assets/images/home/body.png" alt="" />
              <p>场地设施</p>
            </div>
          </router-link>
          <router-link target="_blank" :to="{path: '/school/list', query: {organUuid:centerInfo.youth.organUuid,youthUuid:centerInfo.youth.uuid}}"  class="link" v-if="centerInfo.types.includes('school') || centerInfo.types.includes('schooltrain') ">
            <!-- to="/performance/phaselist" -->
            <div class="box">
              <img src="@/assets/images/home/squad.png" alt="" />
              <p>体教融合</p>
            </div>
          </router-link>
          <router-link target="_blank" :to="{path: '/squad/list', query: {organUuid:centerInfo.youth.organUuid,youthUuid:centerInfo.youth.uuid,squadDissolve:0}}"  class="link" v-if="centerInfo.types.includes('echelon') || centerInfo.types.includes('team') ">
            <!-- to="/performance/phaselist" -->
            <div class="box">
              <img src="@/assets/images/home/squad.png" alt="" />
              <p>球队管理</p>
            </div>
          </router-link>
          <router-link target="_blank" :to="{path: '/player/list', query: {organUuid:centerInfo.youth.organUuid,youthUuid:centerInfo.youth.uuid}}"  class="link" v-if="centerInfo.types.includes('echelon') || centerInfo.types.includes('player')">
            <!-- to="/performance/phaselist" -->
            <div class="box">
              <img src="@/assets/images/home/player.png" alt="" />
              <p>球员数据</p>
            </div>
          </router-link>

        </div>

        <div class="mokuai" v-if="centerInfo.types.includes('coach') || centerInfo.types.includes('train') || centerInfo.types.includes('match')|| centerInfo.types.includes('camp')|| centerInfo.types.includes('coachlevel')|| centerInfo.types.includes('major')|| centerInfo.types.includes('compositeteam')|| centerInfo.types.includes('event')|| centerInfo.types.includes('playertalent')|| centerInfo.types.includes('rank')  || centerInfo.types.includes('team')  || centerInfo.types.includes('qualityoftalents')">

          <router-link target="_blank" :to="{path: '/coach/list',query: {organUuid:centerInfo.youth.organUuid,youthUuid:centerInfo.youth.uuid}}"  class="link" v-if="centerInfo.types.includes('coach') || centerInfo.types.includes('coachlevel')|| centerInfo.types.includes('major')|| centerInfo.types.includes('compositeteam')">
            <!-- to="/performance/phaselist" -->
            <div class="box">
              <img src="@/assets/images/home/teacher.png" alt="" />
              <p>教练员管理</p>
            </div>
          </router-link>
          <router-link target="_blank" :to="{path: '/plan/list', query: {organUuid:centerInfo.youth.organUuid,youthUuid:centerInfo.youth.uuid,youthShortName:centerInfo.youth.youthShortName}}"  class="link" v-if="centerInfo.types.includes('train') || centerInfo.types.includes('event') ">
            <!-- to="/performance/phaselist" -->
            <div class="box">
              <img src="@/assets/images/home/train.png" alt="" />
              <p>训练计划</p>
            </div>
          </router-link>
          <router-link target="_blank" :to="{path: '/tutorial/centerTutorial', query: {uuid:centerInfo.youth.uuid,name:centerInfo.youth.youthShortName}}"  class="link" v-if="centerInfo.types.includes('train')">
            <!-- to="/performance/phaselist" -->
            <div class="box">
              <img src="@/assets/images/home/library.png" alt="" />
              <p>教案库</p>
            </div>
          </router-link>
          <router-link target="_blank" :to="{path: '/talentSendPlayer/list', query: {organUuid:centerInfo.youth.organUuid,youthUuid:centerInfo.youth.uuid}}"  class="link" v-if=" centerInfo.types.includes('camp') || centerInfo.types.includes('playertalent')|| centerInfo.types.includes('rank')|| centerInfo.types.includes('qualityoftalents')">
            <!-- to="/performance/phaselist" -->
            <div class="box">
              <img src="@/assets/images/home/playerTalent.png" alt="" />
              <p>培养成效</p>
            </div>
          </router-link>
          <router-link target="_blank" :to="{path: '/match/list_tournament', query: {organUuid:centerInfo.youth.organUuid,youthUuid:centerInfo.youth.uuid}}"  class="link" v-if=" centerInfo.types.includes('match')  || centerInfo.types.includes('team') ">
            <!-- to="/performance/phaselist" -->
            <div class="box">
              <img src="@/assets/images/home/match.png" alt="" />
              <p>比赛信息</p>
            </div>
          </router-link>

        </div>
      </div>
      <template v-if="isShowUploadScore">
        <downlad-view-club
          :isShow.sync="isShowUploadScore"
          :configInfo="downloadViewInfoForClub"
          @callbackForClub="handleViewCallBackForClub"
        >
        </downlad-view-club>
      </template>
    </template>
  </Content>
</template>

<script>

import 'vue-awesome/icons/regular/edit'
import center from '@/api/center'
import squad from '@/api/squad'
import centerImg from '@/assets/images/common/center.png'
import regions from '@/utils/regions'
import storage from '@/utils/storage'
import mixinAppConfig from "@/mixin/mixinAppConfig";
import { userStatus, centerStatusList } from '@/utils/yioks_data'
import { centerStatus } from '@/utils/yioks_filter'
import squadImg from '@/assets/images/common/squad.png'

export default {
  components: {
    'Content': () => import('@/components/layout/list'),
    'Pagination': () => import('@/components/Pagination'),
    'AddPlayerDialog': () => import('@/components/center'),
    "downlad-view-club": () =>
      import("@/views/export/performance/components/ExpertAuditBaseScore"),
    // 'UploadFile': () => import('@/components/UploadFile')
  },
  filters: {
    statusFilter (val) {
      return centerStatus(val)
    },
    squadDissolve(val){
      if (val)
        return '已停止';
      else
        return '正常';
    },
  },
  mixins: [mixinAppConfig],
  data () {
    return {
      squadImg,
      regions,
      editCenter: false,
      centerImg,
      uuid: '',
      coach: '',
      total: 0,
      page: 0,
      pageSize: 20,
      empty: false,
      showList: false,
      addCenterBtn: false,
      centerStatusList,
      centerInfo: {
        user: {},
        youth: {},
        youthHeader: {},
        types: [],
        stageUuid:"",
        stageScoreStatus:"",
        playerCareerNum:"",
      },
      loading: false,
      isEdit: true,
      userStatus,
      selectVal: {
        key: ''
      },
      squadList: [],
      userRole: storage.get('userInfo').userRole,
      isShowUploadScore: false,
      downloadViewInfoForClub: {},
    }
  },
  created () {
    const uuid = this.$route.query.uuid
    this.uuid = uuid
    // this.getCoachAccount()
    this.getCenterInfo()
    this.getSquadList()
  },
  methods: {
    handleUploadScore(isDisabled){
      this.downloadViewInfoForClub = {
        stageUuid: this.centerInfo.stageUuid,
        youthUuid: this.uuid,
        isDisabled: isDisabled || false,
      };
      this.isShowUploadScore = true;
    },
    goStatistics(){
      this.$router.push({
        path: '/statisticsYouth',
        query: {
          uuid:this.uuid
        }
      })
    },
    goSiteFacilities(organUuid,youthUuid){
      this.$router.push({
        path: "/siteFacilities/list",
        query: {
          organUuid,
          youthUuid
        },
      });
    },
    goSchool(organUuid,youthUuid){
      this.$router.push({
        path: "/school/list",
        query: {
          organUuid,
          youthUuid
        },
      });
    },
    getCenterInfo () {
      center.getCenterInfo(this.uuid).then((res) => {
        this.centerInfo.user = res.user
        this.centerInfo.youth = res.youth
        this.centerInfo.youthHeader = res.youthHeader
        this.centerInfo.types = res.types
        this.centerInfo.playerCareerNum = res.playerCareerNum
        if(res.stageUuid){
          this.centerInfo.stageUuid = res.stageUuid
        }
        if(res.stageScoreStatus){
          this.centerInfo.stageScoreStatus = res.stageScoreStatus
        }else{
          this.centerInfo.stageScoreStatus = "";
        }
      })
    },
    getSquadList () {
      this.loading = true
      this.empty = false
      this.showList = false
      let request
      if (this.userRole === 'system' || this.userRole === 'admin' || this.userRole === 'expert') {
        request = squad.getSquadBySystem
      } else if (this.userRole === 'organ') {
        request = squad.getSquadByOrg
      } else if (this.userRole === 'youth' || this.userRole === 'trainCamp' || this.userRole === 'club') {
        request = squad.getSquadByYouth
      }
      request({ page: this.page, size: this.pageSize, key: this.selectVal.keyWord, youthUuid: this.uuid }).then((res) => {
        this.loading = false
        this.total = res.totalElements
        if (res.content.length) {
          this.squadList = res.content
          this.showList = true
        } else {
          this.empty = true
        }
      }).catch((err) => {
        this.loading = false
        console.error(err)
      })
    },
    goInfo (uuid) {
      this.$router.push({
        path: '/squad/detail',
        query: {
          uuid
        }
      })
    },
    goDetail(organUuid,youthUuid,youthShortName,squadUuid) {
      this.$router.push({
        path: "/plan/list",
        query: {
          organUuid,
          youthUuid,
          youthShortName,
          squadUuid
        },
      });
    },
    hideDialog (val) {
      this.editCenter = val
      this.getCenterInfo()
    },
    // club弹窗信息回调
    handleViewCallBackForClub(flag) {
      if (flag) {
        this.getCenterInfo();
      }else{
        this.isShowUploadScore = false;
      }

    },
  }
}
</script>
<style lang="stylus">
  @import '~@/assets/css/variable'
  .infoViewExpert{
    .contentMain{
      height: 25% !important;
    }
  }
</style>
<style lang="stylus" scoped>
  @import '~@/assets/css/variable'
  .mainHead
    padding 15px 20px 0
    .headInfo
      display flex
      border-bottom 1px solid white
      .logo
        display: flex;
        justify-content: center;
        align-items: center
        img
          width 105px
      .info
        width: calc(100% - 210px);
        padding 0 10px
        flex  1 1 auto
        .row
          margin 10px 0
          display flex
          .item
            margin 0 15px
      .btn
        width 105px
        display: flex;
        justify-content: center;
        align-items: center
  .mainInfo
    height:430px
    .mokuai
      flex 1 1 auto
      display flex
      margin-top 15px
      .link
        width 280px
        flex 1 1 auto
        .box
          height 200px
          width 100%
          display flex
          justify-content center
          align-items center
          flex-direction column
          p
            text-align center
      a
        background $black_color
        box-sizing border-box
        margin-right 30px
        border 2px solid transparent
        display flex
        justify-content center
        align-items center
        flex-direction column
        font-size 24px
        &:hover
          border 2px solid $green_color
          box-shadow inset 0 0 12px $green_color
          background rgba(0, 0, 0, 0.7) url('~@/assets/images/common/hover_yioks.png') no-repeat right center
          background-size 140px 204px
        &:last-child
          margin-right 0
        p
          &:last-child
            margin-top 12px
            font-size 16px
        img
          width 55px
          height 55px
          margin-bottom 5px
.bg_btn
  border 1px solid #fff
  padding 10px 16px
  text-align center
  cursor pointer
  &:hover
    background #5ac8fa
</style>

